import React, {useState, ReactElement, useRef, useEffect} from "react"
import useIsOverflow from "../../lib/useIsOverflow";

interface PaginatedContentProps {
    height: string,
    children: JSX.Element | JSX.Element[],
    showAllOnClick?: boolean,
    showLessOnAll?: boolean,
    className?: string,
}

const PaginatedContent: React.FC<PaginatedContentProps> = ({ height, showAllOnClick = false, className = '', 
    showLessOnAll = false, children}): ReactElement => {
    const containerRef = useRef<HTMLDivElement>(null);
    const isOverflow = useIsOverflow(containerRef);
    const [counter, setCounter] = useState(1);
    const [maxHeight, setMaxHeight] = useState(`calc(${height} * var(--multiplier))`);
    const mask = 'linear-gradient(0deg, rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.9) 2rem, rgb(255, 255, 255) 100%)';

    const handleReadMore = () => showAllOnClick ?
        () => setMaxHeight(isOverflow ? `${containerRef.current?.scrollHeight}px` : height) : 
        () => setCounter(isOverflow ? counter + 1 : 1);

    return (
        <>
            <div className={`overflow-hidden transition-[max-height] ease-in-out duration-500 ${className}`} ref={containerRef} 
                style={{
                    '--multiplier': counter,
                    maxHeight: maxHeight,
                    maskImage: isOverflow ? mask : '',
                    WebkitMaskImage: isOverflow ? mask : ''} as React.CSSProperties}>
                {children}
            </div>
            <div className={`w-full px-0 gap-4 flex flex-row items-center justify-center my-4 
                ${isOverflow || (showLessOnAll && (counter > 1 || !maxHeight.startsWith('calc') ))?'':'hidden'}`}>
                <div className="flex-1 h-0 w-full border-deep-blue opacity-25 border-[2px] rounded-[4px] flex-grow" />
                <div className="text-vibrant-green body cursor-pointer font-ibmPlexSansSemiBold" onClick={handleReadMore()}>Show {isOverflow ? 'More' : 'Less'}...</div>
            </div>
        </>
    );
};

export default PaginatedContent;
